import {useState,useRef} from "react"
import { IconButton } from "@mui/material"
import Box from "@mui/material/Box"
import EditIcon from '@mui/icons-material/Edit';
import DoneIcon from '@mui/icons-material/Done';
import ERPSnakBar from "./ERPSnakBar";
import { updateRemarks } from "../services/shipDataService";

function UpdateRemarks({id,value,getUpdateList}:{id:number,value:any,getUpdateList:React.Dispatch<React.SetStateAction<void>>}) {

    const handleUpdateRemarks = async ()=> {
        try {
          const response = await updateRemarks(id, remark);
          if (response.status) {
            setAlert({
              open: true,
              message: "Remarks updated successfully",
              serverity: "success",
            });
            getUpdateList();
          }
        } catch (error) {
          console.error("Error updating remarks:", error);
        }
    }
    const [remark,setRemark]=useState(value)
    const [IsEdit,setIsEdit]=useState(false)
    const inputRef = useRef<HTMLInputElement>(null);
    const [alert, setAlert] = useState({
    open: false,
    message: "",
    serverity: "",
  });
  return (
    <Box component={"div"} sx={{display:"flex",alignItems:"start" }}>
      {IsEdit ? (
        <input
          type="text"
          value={remark}
          onChange={(e) => { setRemark(e.target.value) }}
          
          multiple
            ref={inputRef}
          style={{ width: "100%", height: "25px", fontSize: "0.7rem",padding:"4px" }}
        />
      ) : (
        <span>{remark}</span>
      )}
      {IsEdit ? (
        <IconButton
          color="success"
          size="small"
          onClick={() => {
            handleUpdateRemarks();
            setIsEdit(false);
            getUpdateList();
          }}
        >
          <DoneIcon sx={{fontSize:"18px"}} />
        </IconButton>
      ) : (
        <IconButton
          color="primary"
          size="small"
          onClick={() => {setIsEdit(true); inputRef.current?.focus()}}
        >
          <EditIcon sx={{fontSize:"15px"}}/>
        </IconButton>
      )}
      <ERPSnakBar
        open={alert.open}
        message={alert.message}
        serverity={alert.serverity}
        onClose={() => setAlert({ open: false, message: "", serverity: "" })}
      />
    </Box>
  )
}

export default UpdateRemarks
